// src/pages/Regions.js
import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import SideMenu from '../components/SideMenu';
import RegionManagement from '../settings/RegionManagement';
import { usePageTour } from '../tours/usePageTour';

const Regions = () => {
  usePageTour('regions');
  return (
    <>
      <SideMenu />
      <Container maxWidth={false}>
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Region Management
        </Typography>
        <Card data-tour="regions-list">
          <CardContent>
            <RegionManagement />
          </CardContent>
        </Card>
      </Box>
      </Container>
    </>
  );
};

export default Regions;
